const { browserTrackPage, browserTrackCTAClick, initSegment } = require('./src/utils/segment');
const { getReferrerData } = require('./src/utils/urlUtilities');

exports.onClientEntry = () => {
  // Load segment with current environment key
  initSegment();
};

exports.onRouteUpdate = () => {
  // Track page viewed event, most properties in protocols
  // are added by segment.page() method
  let category = window.location.pathname.replace(/^\/([^/]*).*$/, '$1');
  let referrerData = getReferrerData();
  browserTrackPage('Page Viewed', {
    category: category === '' ? 'home-page' : category,
    url: window.location.href,
    referrer: referrerData.referrer,
    referring_domain: referrerData.referringDomain,
  });

  // Track CTA Clicked event, addeding necessary
  // properties from the button/page context
  const setupCTAClicked = (className) => {
    document.querySelectorAll(className).forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = e.target;
        const classes = Array.from(target.classList);

        let location = '';
        if (target.closest('header')) {
          location = 'navigation';
        } else if (target.closest('main')) {
          location = 'body';
        } else if (target.closest('footer')) {
          location = 'footer';
        }

        let style = '';
        if (classes.includes('htco-isSolid')) {
          style = 'primary';
        } else if (classes.includes('htco-isOutlined')) {
          style = 'secondary';
        } else if (classes.includes('htco-isTextButton')) {
          style = 'tertiary';
        }

        browserTrackCTAClick({
          destination: target.href,
          location: location,
          text: target.innerText,
          type: 'button',
          style: style,
        });
      });
    });
  };

  // Add CTA Clicked event to all primary buttons
  // as well as any button with the class .cta-segment-track
  setTimeout(() => {
    setupCTAClicked('.htco-Button.htco-isSolid');
    setupCTAClicked('.cta-segment-track');
  }, 500);
};
